export async function base64ToFile(base64String, filename) {
    // Split the base64 string to remove the data URL part
    const byteString = atob(base64String.split(',')[1]);

    // Create an array buffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);

    // Convert the binary data to a Uint8Array
    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    // Create a Blob from the array buffer
    const blob = new Blob([ab], { type: 'application/octet-stream' }); // Adjust type if needed

    // Optionally, create a File object from the Blob if needed
    return new File([blob], filename, { type: blob.type });
}
